import { useCallback } from 'react';
import { fetchUserProfile, toggleVisit, UserProfile } from '../services/api';
import { useTempVisits } from './useTempVisits';
import { Analytics } from '../services/analytics';

export const useCompleteSignIn = (onProfileUpdate: (profile: UserProfile) => void, onSuccess?: () => void) => {
  const { tempVisits, clearTempVisits } = useTempVisits();
  return useCallback(async (token: string, method: string, isNewAccount = false) => {
    localStorage.setItem('token', token);
    if (tempVisits.length) {
      try {
        for (const visit of tempVisits) await toggleVisit(visit.venueId, new Date(visit.date));
        clearTempVisits();
      } catch {
        Analytics.logError('Login', 'Failed to process temporary visits', 'high');
      }
    }
    const profile = await fetchUserProfile();
    onProfileUpdate(profile);
    if (isNewAccount) {
      try { Analytics.signUp(method, profile.id); } catch { /* Tracking must not block sign-in. */ }
    }
    Analytics.logAuth.signIn(method, true);
    onSuccess?.();
  }, [tempVisits, clearTempVisits, onProfileUpdate, onSuccess]);
};
